<template>
  <div class="d-flex flex-row mb-4">
    <div class="card flex-shrink-1" style="padding: 10px; background-color: #F2F2F2; border-radius: 0; width: 100%; height: 100%">
      <div class="d-flex flex-row p-2">

        <img :src="newsletter.upload" class="img-fluid" width="195"/>
        <div class="d-flex flex-column" style="width: 100%">
          <small class="pl-2">{{ newsletter.title }}</small>
          <span class="flex-shrink-1 p-2 ellipsis-container">
            <span class="ellipsis-text" v-html="newsletter.description"></span>
          </span>
          
          <div class="align-self-end align-text-bottom">
            <a :href="newsletter.link" target="_blank" class="btn btn-primary">TAP TO READ</a>
          </div>
        </div>
      </div>
    </div>

    <div class="card flex-shrink-1 px-4" style="padding: 10px; border-radius: 0; width: 200px">
      <span class="d-flex flex-column">
        <button @click="handleActivate(newsletter)" class="btn btn-block" :class="`${newsletter.status ? 'btn-danger' : 'btn-success'}`">
          {{ newsletter.status ? 'Deactivate' : 'Activate' }}
        </button>
        <router-link
          :to="goTo(newsletter.id)"
          type="button"
          class="btn btn-success btn-block"
          >Edit Details</router-link
        >
      </span>
    </div>
  </div>
</template>

<script>
import { changeNewsletterStatus } from '../../../services/NewsletterService';
export default {
  props: ['newsletter', 'fetchDatas'],

  methods: {
    goTo(id) {
      return `/marketing/newsletter/edit/${id}`;
    },


    async handleActivate(dataObject) {
      try {
        const response = await changeNewsletterStatus({}, this.newsletter.id, dataObject.status ? 0 : 1);
        if(response.data.success) {
          this.fetchDatas();
        }
      } catch (e) {
        console.error(e)
      }

    },
  },
}


</script>
